/**
 * List of Internal Statuses
 */
export const INTERNAL_STATUS_WAITING_PICKUP = 'Waiting Pickup'
export const INTERNAL_STATUS_REFUNDED = 'Refunded'
export const INTERNAL_STATUS_PICKED_UP = 'Picked up'
export const INTERNAL_STATUS_IN_TRANSIT = 'In transit'
export const INTERNAL_STATUS_PROCESSING = 'Processing'
export const INTERNAL_STATUS_DELIVERED = 'Delivered'
export const INTERNAL_STATUS_ON_DELIVERY = 'On Delivery'
export const INTERNAL_STATUS_PROBLEMATIC_PROCESSING = 'Problematic Processing'
export const INTERNAL_STATUS_CUSTOM_MATTER = 'Custom matter'
export const INTERNAL_STATUS_SELF_COLLECT = 'Self Collect'
export const INTERNAL_STATUS_RETURN_IN_TRANSIT = 'Return in transit'
export const INTERNAL_STATUS_RETURNED = 'Returned'
export const INTERNAL_STATUS_SHIPMENT_DATA_RECEIVED = 'Shipment Data Received'
export const INTERNAL_STATUS_CLOSED = 'Closed'
export const INTERNAL_STATUS_CANCELLED = 'Cancelled'
export const INTERNAL_STATUS_CANCELLED_BY_USER = 'Cancelled by User'
export const INTERNAL_STATUS_COD_AMOUNT_DEPOSITED = 'COD amount deposited'
export const INTERNAL_STATUS_COD_AMOUNT_REMITTED = 'COD amount remitted'
export const INTERNAL_STATUS_CANCEL_REQUEST_BY_USER = 'Cancel Requested by User'
export const INTERNAL_STATUS_CANCELLED_BY_COURIER = 'Cancelled by Courier'
export const INTERNAL_STATUS_RETURNED_INITIATED = 'Returned Initiated'
export const INTERNAL_STATUS_DETAINED = "Detained"
export const INTERNAL_STATUS_PICKUP_FAILED = "Pickup Failed"
export const INTERNAL_STATUS_LOST = "Lost"

export const MISS_PICKUP_STATUS = [
  INTERNAL_STATUS_WAITING_PICKUP,
  INTERNAL_STATUS_SHIPMENT_DATA_RECEIVED,
  INTERNAL_STATUS_PICKUP_FAILED
];

export const INTERNAL_STATUSES = [
  INTERNAL_STATUS_WAITING_PICKUP,
  INTERNAL_STATUS_REFUNDED,
  INTERNAL_STATUS_PICKED_UP,
  INTERNAL_STATUS_IN_TRANSIT,
  INTERNAL_STATUS_PROCESSING,
  INTERNAL_STATUS_DELIVERED,
  INTERNAL_STATUS_ON_DELIVERY,
  INTERNAL_STATUS_PROBLEMATIC_PROCESSING,
  INTERNAL_STATUS_CUSTOM_MATTER,
  INTERNAL_STATUS_SELF_COLLECT,
  INTERNAL_STATUS_RETURN_IN_TRANSIT,
  INTERNAL_STATUS_RETURNED,
  INTERNAL_STATUS_SHIPMENT_DATA_RECEIVED,
  INTERNAL_STATUS_CLOSED,
  INTERNAL_STATUS_CANCELLED,
  INTERNAL_STATUS_CANCELLED_BY_USER,
  INTERNAL_STATUS_COD_AMOUNT_DEPOSITED,
  INTERNAL_STATUS_COD_AMOUNT_REMITTED,
  INTERNAL_STATUS_CANCEL_REQUEST_BY_USER,
  INTERNAL_STATUS_CANCELLED_BY_COURIER,
  INTERNAL_STATUS_RETURNED_INITIATED,
  INTERNAL_STATUS_PICKUP_FAILED,
  INTERNAL_STATUS_LOST,
]

export const INACTIVE_ORDER_STATUS = [
  INTERNAL_STATUS_REFUNDED,
  INTERNAL_STATUS_CANCELLED_BY_USER,
  INTERNAL_STATUS_CANCELLED_BY_COURIER
]

export const ACTIVE_INTERNAL_STATUSES = INTERNAL_STATUSES.filter(
  status => !INACTIVE_ORDER_STATUS.includes(status)
);


